/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddVehiclesRequest } from '../models/AddVehiclesRequest';
import type { AddVehiclesResponse } from '../models/AddVehiclesResponse';
import type { Certificate } from '../models/Certificate';
import type { CheckVehicleReviewRequest } from '../models/CheckVehicleReviewRequest';
import type { CreateCertificateNoteRequest } from '../models/CreateCertificateNoteRequest';
import type { CreateVehicleReviewRequestResult } from '../models/CreateVehicleReviewRequestResult';
import type { DrugCert } from '../models/DrugCert';
import type { ExportFormat } from '../models/ExportFormat';
import type { GetCertificateRenewalFeesRequest } from '../models/GetCertificateRenewalFeesRequest';
import type { GetCertificateRenewalFeesResponse } from '../models/GetCertificateRenewalFeesResponse';
import type { GetCertificateRenewalInsuranceResponse } from '../models/GetCertificateRenewalInsuranceResponse';
import type { ListCertificateNotesResponse } from '../models/ListCertificateNotesResponse';
import type { mccs_vehicle_review_request_reason } from '../models/mccs_vehicle_review_request_reason';
import type { mccs_vehicle_review_request_source } from '../models/mccs_vehicle_review_request_source';
import type { ReActivateCertificateRequest } from '../models/ReActivateCertificateRequest';
import type { RenewalBlockedResponse } from '../models/RenewalBlockedResponse';
import type { RenewCertificateRequest } from '../models/RenewCertificateRequest';
import type { RenewCertificateResponse } from '../models/RenewCertificateResponse';
import type { RevokeCertificateRequest } from '../models/RevokeCertificateRequest';
import type { SetSelfInsuranceAmountRequest } from '../models/SetSelfInsuranceAmountRequest';
import type { SortDirection } from '../models/SortDirection';
import type { StartReApplicationResponse } from '../models/StartReApplicationResponse';
import type { UpdateVehicleRequest } from '../models/UpdateVehicleRequest';
import type { UpdateVehicleResponse } from '../models/UpdateVehicleResponse';
import type { VehicleBulkImportStatusResponse } from '../models/VehicleBulkImportStatusResponse';
import type { VehicleInfo } from '../models/VehicleInfo';
import type { VehicleListResult } from '../models/VehicleListResult';
import type { VehicleReviewCheckResult } from '../models/VehicleReviewCheckResult';
import type { VehicleSortBy } from '../models/VehicleSortBy';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CertificateService {
  /**
   * Get a certificate by its number.
   * @param certificateNumber
   * @returns Certificate OK
   * @throws ApiError
   */
  public static get(
    certificateNumber: string,
  ): CancelablePromise<Certificate> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Certificate/{certificateNumber}',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Gets authorization card PDFs
   * @param certificateNumber
   * @returns binary OK
   * @throws ApiError
   */
  public static getCertificateAuthCards(
    certificateNumber: string,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/certificate/{certificateNumber}/auth-card',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Voluntarily surrender a certificate.
   * @param certificateNumber
   * @returns any OK
   * @throws ApiError
   */
  public static voluntarilySurrender(
    certificateNumber: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/voluntary-surrender',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Revoke a certificate.
   * @param certificateNumber
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static revoke(
    certificateNumber: string,
    requestBody?: RevokeCertificateRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/revoke',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Reactivate a revoked or expired certificate.
   * @param certificateNumber
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static reactivate(
    certificateNumber: string,
    requestBody?: ReActivateCertificateRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/re-activate',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * List vehicles associated with a certificate. Returns JSON by default, or CSV when format is specified.
   * @param certificateNumber
   * @param query
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param excludeArchived
   * @param activeOnly
   * @param format
   * @returns VehicleListResult OK
   * @throws ApiError
   */
  public static getCertificateVehicles(
    certificateNumber: string,
    query?: string,
    limit?: number,
    offset?: number,
    sortBy?: VehicleSortBy,
    sortDirection?: SortDirection,
    excludeArchived?: boolean,
    activeOnly?: boolean,
    format?: ExportFormat,
  ): CancelablePromise<VehicleListResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Certificate/{certificateNumber}/vehicles',
      path: {
        'certificateNumber': certificateNumber,
      },
      query: {
        'query': query,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'excludeArchived': excludeArchived,
        'activeOnly': activeOnly,
        'format': format,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Add one or more vehicles to an active certificate (charges the prorated Vehicle Fee).
   * @param certificateNumber
   * @param requestBody
   * @returns AddVehiclesResponse OK
   * @throws ApiError
   */
  public static addVehicles(
    certificateNumber: string,
    requestBody?: AddVehiclesRequest,
  ): CancelablePromise<AddVehiclesResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/vehicles',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Archive a vehicle associated with a certificate
   * @param certificateNumber
   * @param vehicleId
   * @returns VehicleInfo OK
   * @throws ApiError
   */
  public static archiveVehicle(
    certificateNumber: string,
    vehicleId: number,
  ): CancelablePromise<Array<VehicleInfo>> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Certificate/{certificateNumber}/vehicles/{vehicleId}',
      path: {
        'certificateNumber': certificateNumber,
        'vehicleId': vehicleId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Update a vehicle associated with a certificate
   * @param certificateNumber
   * @param vehicleId
   * @param requestBody
   * @returns UpdateVehicleResponse OK
   * @throws ApiError
   */
  public static updateVehicle(
    certificateNumber: string,
    vehicleId: number,
    requestBody?: UpdateVehicleRequest,
  ): CancelablePromise<UpdateVehicleResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Certificate/{certificateNumber}/vehicles/{vehicleId}',
      path: {
        'certificateNumber': certificateNumber,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Report which vehicles need TX review, and for which reasons, before adding them to this certificate or its renewal.
   * @param certificateNumber
   * @param requestBody
   * @returns VehicleReviewCheckResult OK
   * @throws ApiError
   */
  public static checkCertificateVehicleReview(
    certificateNumber: string,
    requestBody?: CheckVehicleReviewRequest,
  ): CancelablePromise<VehicleReviewCheckResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/vehicles/review-check',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Submit a vehicle review request for one vehicle and one reason, with its supporting documents, instead of adding the vehicle to this certificate or its renewal.
   * @param certificateNumber
   * @param formData
   * @returns CreateVehicleReviewRequestResult OK
   * @throws ApiError
   */
  public static createCertificateVehicleReviewRequest(
    certificateNumber: string,
    formData?: {
      Reason?: mccs_vehicle_review_request_reason;
      Source?: mccs_vehicle_review_request_source;
      Vin?: string;
      MakeDescription?: string;
      Model?: string;
      ModelYear?: number;
      UnitNumber?: string;
      Leased?: boolean;
      LeasingCompany?: string;
      LeasingUsdot?: number;
      PassengerCapacity?: number;
      AddToCurrentRegistration?: boolean;
      ReplacesVehicleId?: number;
      Files?: Array<Blob>;
    },
  ): CancelablePromise<CreateVehicleReviewRequestResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/vehicle-review-requests',
      path: {
        'certificateNumber': certificateNumber,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Upload a CSV to bulk create/update vehicles (by VIN) for a certificate. New VINs are charged the standard Vehicle Fee (unless the carrier is interstate/UCR-exempt); existing VINs are updated with no charge. Processed asynchronously in the background; poll GetVehicleBulkImportStatus for progress.
   * @param certificateNumber
   * @param formData
   * @returns VehicleBulkImportStatusResponse Accepted
   * @throws ApiError
   */
  public static bulkUploadVehicles(
    certificateNumber: string,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<VehicleBulkImportStatusResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Certificate/{certificateNumber}/vehicles/bulk',
      path: {
        'certificateNumber': certificateNumber,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get the status of the most recent bulk vehicle CSV import for a certificate.
   * @param certificateNumber
   * @returns VehicleBulkImportStatusResponse OK
   * @throws ApiError
   */
  public static getVehicleBulkImportStatus(
    certificateNumber: string,
  ): CancelablePromise<VehicleBulkImportStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Certificate/{certificateNumber}/vehicles/bulk/status',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @param certificateNumber
   * @returns ListCertificateNotesResponse OK
   * @throws ApiError
   */
  public static getApiCertificateNotes(
    certificateNumber: string,
  ): CancelablePromise<ListCertificateNotesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Certificate/{certificateNumber}/notes',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @param certificateNumber
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postApiCertificateNotes(
    certificateNumber: string,
    requestBody?: CreateCertificateNoteRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/notes',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @param noteId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static putApiCertificateNotes(
    noteId: number,
    requestBody?: CreateCertificateNoteRequest,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Certificate/notes/{noteId}',
      path: {
        'noteId': noteId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param noteId
   * @returns any OK
   * @throws ApiError
   */
  public static deleteApiCertificateNotes(
    noteId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Certificate/notes/{noteId}',
      path: {
        'noteId': noteId,
      },
    });
  }
  /**
   * Update a drug consortium company associated with a certificate
   * @param certificateId
   * @param requestBody
   * @returns VehicleInfo OK
   * @throws ApiError
   */
  public static updateDrugTestingConsortiumCompanies(
    certificateId: string,
    requestBody?: DrugCert,
  ): CancelablePromise<Array<VehicleInfo>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Certificate/{certificateId}/drug-consortium-companies',
      path: {
        'certificateId': certificateId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Get the renewal eligibility for a motor carrier certificate.
   * @param certificateNumber
   * @returns RenewalBlockedResponse OK
   * @throws ApiError
   */
  public static getCertificateRenewalEligibility(
    certificateNumber: string,
  ): CancelablePromise<RenewalBlockedResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Certificate/{certificateNumber}/renew',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Renew a motor carrier certificate with the provided vehicles and registration period.
   * @param certificateNumber
   * @param requestBody
   * @returns RenewCertificateResponse OK
   * @throws ApiError
   */
  public static renewCertificate(
    certificateNumber: string,
    requestBody?: RenewCertificateRequest,
  ): CancelablePromise<RenewCertificateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/renew',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Calculate fees for a motor carrier certificate based on the provided vehicles and registration period.
   * @param certificateNumber
   * @param requestBody
   * @returns GetCertificateRenewalFeesResponse OK
   * @throws ApiError
   */
  public static getCertificateRenewalFees(
    certificateNumber: string,
    requestBody?: GetCertificateRenewalFeesRequest,
  ): CancelablePromise<GetCertificateRenewalFeesResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/renew/fees',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Whether a certificate has the insurance a renewal or re-registration requires, optionally for a chosen Hazmat status.
   * @param certificateNumber
   * @param hazmat
   * @returns GetCertificateRenewalInsuranceResponse OK
   * @throws ApiError
   */
  public static getCertificateRenewalInsurance(
    certificateNumber: string,
    hazmat?: boolean,
  ): CancelablePromise<GetCertificateRenewalInsuranceResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Certificate/{certificateNumber}/renew/insurance',
      path: {
        'certificateNumber': certificateNumber,
      },
      query: {
        'hazmat': hazmat,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Stages a new certificate application, pre-filled from existing data, for a red-bannered certificate.
   * @param certificateNumber
   * @returns StartReApplicationResponse OK
   * @throws ApiError
   */
  public static startReApplication(
    certificateNumber: string,
  ): CancelablePromise<StartReApplicationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Certificate/{certificateNumber}/re-application',
      path: {
        'certificateNumber': certificateNumber,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Set, edit, or clear self-insurance for a certificate.
   * @param certificateNumber
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static setSelfInsuranceAmount(
    certificateNumber: string,
    requestBody?: SetSelfInsuranceAmountRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Certificate/{certificateNumber}/self-insurance',
      path: {
        'certificateNumber': certificateNumber,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Unprocessable Content`,
      },
    });
  }
}
